var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h4',{staticClass:"alert alert-danger"},[_vm._v(" "+_vm._s(_vm.$t("HALL_IS_NOT_LOADED_WITH_RAW_PRODUCTS_AND_MATERIALS"))+" "+_vm._s(_vm._f("formatDateTime")(_vm.routemap.materialDate))+" "+_vm._s(_vm.$t("YEAR_ABBR"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }